__webpack_require__.p = "/trip-cards-app/";